import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import {
  EmptyState,
  EmptyStateActions,
  Button,
  IconPlus,
  Text
} from '@vtex/shoreline'

import s from './styles.module.css'

interface ScreensGroupsEmptyStateProps {
  handleClick: () => void
}

export default function ScreensGroupsEmptyState({
  handleClick
}: ScreensGroupsEmptyStateProps) {
  const { t } = useAPPTranslation()

  return (
    <EmptyState className={s.emptyStateContainer}>
      <Text variant="body" className={s.marginZero}>
        {t('rm:campaign.create.ScreenGroups.EmptyState.description')}
      </Text>
      <EmptyStateActions>
        <Button onClick={handleClick}>
          <IconPlus />
          {t('rm:campaign.create.ScreenGroups.EmptyState.buttonLabel')}
        </Button>
      </EmptyStateActions>
    </EmptyState>
  )
}
